import auth from '../../middleware/auth';

const props = (route) => {
	return {
		clientId: parseInt(route.params.id)
	};
};

export default {
	path: 'mag-templates',
	name: 'client-mag-templates',
	props: props,
	component: () => import('../../../views/MonitorActionGroupTemplates'),
	meta: {
		collapse: true,
		static: false,
		middleware: [
			auth
		]
	}
};
